import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePayImportChecksPage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayImportChecksPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayImportChecksTemplateDD
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks" capture group.
 */
export default function CapturePositivePayImportChecksTemplateDD(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    defaultData.defaultTemplate.id = "0";
    defaultData.defaultTemplate.name = "Sample";
    defaultData.templates = [ defaultData.defaultTemplate ];

    const data = BCMSStateManagerCRUD.init(defaultData)
    .submit();

    const ui = BCMSStateManagerCRUD.init( getDefaultUI())
    .update([ "showNewTemplateBanner", "isActive" ], true)
    .update([ "chooseTemplateSelect", "isActive" ], true)
    .submit();

    return <TASPositivePayImportChecksPage data={ data } ui={ ui }  />;
}